import { fetchClient } from '../lib/openapi-query';

export interface CopyLocaleRequest {
  fromLocale: string;
  toLocale: string;
}

export interface CopyLocaleResponse {
  copied: number;
}

export const copyLocaleApi = {
  copyRecommendations: async (data: CopyLocaleRequest): Promise<CopyLocaleResponse> => {
    const response = await fetchClient.POST('/products/activity-recommendations/copy-locale' as any, {
      body: data as any
    });

    if (response.error) {
      throw new Error('Failed to copy activity recommendations');
    }

    return response.data as unknown as CopyLocaleResponse;
  }
};
